import * as bootstrap from 'bootstrap'

// This function runs on every page load (standard or Turbo navigation)
document.addEventListener("turbo:load", () => {

  // 1. Update Footer Year
  const yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();
  // 2. Smooth Scrolling (Optional - CSS scroll-behavior: smooth often handles this,
  // but keeping your JS logic for specific control)
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      const href = a.getAttribute("href");
      if (!href || href === "#") return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      history.pushState(null, "", href);
    });
  });
})
